import React from "react";
import EnterprisePlan from "./EnterprisePlan";
import FreePlan from "./FreePlan";
import PioneerPlan from "./PioneerPlan";
import { Button } from "antd";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PricingActions from "../../redux/actions";
import ProductOverview from "./ProductOverview";
import "../../plans.scss";
import paymentsService from "../../../../common/services/payments-service";

const PlansOverview = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.authUser);
  const history = useHistory();

  // const handleProPlan = (e) => {
  //   setProPlan(e);
  // };
  const handlePioneerClick = (e) => {
    if (!user) {
      dispatch(PricingActions.pricingStateChanged("checkout"));
      history.push("/signin");
      return;
    }
    paymentsService
      .createSession({
        priceId: "price_1KQjcODD6XrDuzW97XZ2tsoC",
        user: user,
        successUrl: "https://mobile-vizcom.web.app/s2r",
        cancelUrl: "https://mobile-vizcom.web.app/s2r",
      })
      .then((session) => {
        // reroute to checkout
        window.location.href = session.data.url;
      })
      .catch((error) => {
        console.log(error);
      });
    window.analytics.track("Payment Action", {
      action: "pioneer click",
      device: "mobile",
    });
  };

  const handleEnterpriseClick = (e) => {
    dispatch(PricingActions.pricingStateChanged("enterprise"));
    window.analytics.track("Payment Action", {
      action: "enterprise click",
      device: "mobile",
    });
  };

  const freeRoute = user ? "/s2r" : "/signin";

  return (
    <>
      <div data-aos="fade-in" className="row title">
        <h1>Ready to get started?</h1>
        <p style={{ fontSize: "12px" }}>
          Vizcom plans and prices flex to fit your digital experience needs and
          goals.
        </p>
      </div>
      {/* <div
        className="row"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <Switch
          checkedChildren="Monthly"
          unCheckedChildren="Annual"
          onChange={(e) => handleProPlan(e)}
        />
      </div> */}
      <div data-aos="fade-up" className="plans-container">
        {/* {proPlan ? <MonthlyPlan /> : <AnnualPlan />} */}
        <div className=" buttons">
          <div className="col s12">
            <FreePlan />
            <Link to={freeRoute}>
              <Button
                onClick={() => {
                  window.analytics.track("Payment Action", {
                    action: "free click",
                    device: "mobile",
                  });
                }}
                style={{
                  width: "90%",
                  margin: "auto",
                  display: "block",
                  marginTop: "20px",
                }}
                className="coming-soon"
                type="primary"
              >
                Continue
              </Button>
            </Link>
          </div>
          <div className="col s12">
            <PioneerPlan />

            <Button
              className="coming-soon"
              type="primary"
              style={{
                width: "90%",
                margin: "auto",
                display: "block",
                marginTop: "20px",
              }}
              onClick={() => {
                handlePioneerClick();
              }}
            >
              Start 7-day trial
            </Button>
          </div>
          <div className="col s12 ">
            <EnterprisePlan />

            <Button
              onClick={() => {
                handleEnterpriseClick();
              }}
              style={{
                width: "90%",
                marginTop: "20px",
                margin: "auto",
                display: "block",
              }}
              className="coming-soon"
              type="primary"
            >
              Contact us
            </Button>
          </div>
        </div>
      </div>

      <div className="row contact-info">
        <h2>(Plan details and pricing are subject to change)</h2>
        <p> Contact: contact@vizcom.co</p>
        <a href="">
          <p>Learn more</p>
        </a>
      </div>

      <ProductOverview />
    </>
  );
};
export default PlansOverview;
